import InputField, { InputTitle } from "@Molecule/InputField";
import Styles from "./styles.module.scss";
import Dropdown from "@Atom/DropDown";
import ToggleButtonPIC from "@Atom/ToggleButtonPIC";
import Radio from "@Atom/Radio";
import Icon from "@Atom/Icon";
import AutocompleteV2 from "@Atom/AutocompleteV2";
// import { ToggleButton } from "@mui/material";

export default function FirstStep({
  firstStep,
  setFirstStep,
  validate,
  getDropdownList,
}) {
  const handleChange = (e, name) => {
    setFirstStep((prev) => ({
      ...prev,
      [name]: e,
    }));
  };

  return (
    <div className={Styles.container}>
      <InputField
        value={firstStep?.positionName}
        title="Nama Posisi"
        placeholder="Masukkan nama posisi"
        onChange={(e) => {
          const input = e.target;
          const startPos = input.selectionStart;
          const endPos = input.selectionEnd;
          let newValue = input.value;

          newValue = newValue.toUpperCase();
          handleChange(newValue, "positionName");

          setTimeout(() => {
            if (document.activeElement === input) {
              input.setSelectionRange(startPos, endPos); // Pastikan input masih fokus sebelum set cursor
            }
          }, 0);
        }}
        required
        isError={validate && !firstStep?.positionName}
        errorText="*Nama posisi belum diisi"
      />

      <div className={Styles.formBox}>
        <div className={Styles.headerForm}>
          <InputTitle title={"Kategori Posisi"} required={true} />
        </div>
        <Dropdown
          autoClose
          value={firstStep?.categoryPosition}
          setValue={(e) => handleChange(e, "categoryPosition")}
          isError={validate && !firstStep?.categoryPosition}
          errorText="*Kategori posisi belum dipilih"
          placeholder={"Pilih kategori posisi"}
          options={
            getDropdownList?.categories?.map((el) => {
              return {
                name: el,
              };
            }) || []
          }
        />
      </div>

      <div className={Styles.formBox}>
        <div className={Styles.headerForm}>
          <InputTitle title={"Lokasi Tempat Bekerja"} required={true} />
        </div>
        <AutocompleteV2
          autoClose
          onClickOption={(e) => {
            handleChange(e?.code, "cityCode");
          }}
          value={firstStep?.location}
          setValue={(e) => handleChange(e, "location")}
          isError={validate && !firstStep?.location}
          isErrorText={validate && !firstStep?.location}
          errorText="*Lokasi tempat bekerja belum dipilih"
          placeholder={"Pilih tempat lokasi kerja"}
          options={getDropdownList?.cities || []}
        />
      </div>

      <div className={Styles.formWrapper}>
        <div className={Styles.formBox}>
          <div className={Styles.headerForm}>
            <InputTitle title={"Jenis Tempat Kerja"} required={true} />
          </div>
          <Dropdown
            autoClose
            value={firstStep?.workplaceType}
            setValue={(e) => handleChange(e, "workplaceType")}
            isError={validate && !firstStep?.workplaceType}
            errorText="*Jenis tempat kerja belum dipilih"
            placeholder={"Pilih jenis tempat kerja"}
            options={
              getDropdownList?.workMethods?.map((el) => {
                return {
                  name: el,
                };
              }) || []
            }
          />
        </div>
        <div className={Styles.formBox}>
          <div className={Styles.headerForm}>
            <InputTitle title={"Status Karyawan"} required={true} />
          </div>
          <Dropdown
            autoClose
            value={firstStep?.employeeStatus}
            setValue={(e) => handleChange(e, "employeeStatus")}
            isError={validate && !firstStep?.employeeStatus}
            errorText="*Status karyawan belum dipilih"
            placeholder={"Pilih status karyawan"}
            options={
              getDropdownList?.workSystems?.map((el) => {
                return {
                  name: el,
                };
              }) || []
            }
          />
        </div>
      </div>

      <div className={`${Styles.formWrapper} ${Styles.formWrapperSalary}`}>
        <div className={Styles.rangeSalaryTitle}>
          <InputTitle title={"Range Gaji"} required={true} />
          <div className={`${Styles.toggleButton}`}>
            <ToggleButtonPIC
              isPIC={firstStep?.showSalary}
              handleIsPIC={() => handleChange(true, "showSalary")}
              handleNotPIC={() => handleChange(false, "showSalary")}
            />

            <span>Jangan tampilkan range gaji</span>
          </div>
        </div>
        <div className={Styles.rangeSalaryInput}>
          <div className={Styles.formBox}>
            <InputField
              value={firstStep?.minSalary}
              placeholder="Masukkan range gaji"
              onChange={(e) => {
                handleChange(e, "minSalary");
              }}
              required
              isCurrency
              isError={validate && !firstStep?.minSalary}
              errorText={"*Range gaji belum diisi"}
            />
          </div>

          <div className={Styles.formBox}>
            <InputField
              value={firstStep?.maxSalary}
              placeholder="Masukkan range gaji"
              onChange={(e) => {
                handleChange(e, "maxSalary");
              }}
              required
              isCurrency
              isError={
                (validate && !firstStep?.maxSalary) ||
                (validate &&
                  firstStep?.minSalary &&
                  firstStep?.maxSalary &&
                  +firstStep?.maxSalary < +firstStep?.minSalary)
              }
              errorText={
                validate &&
                firstStep?.minSalary &&
                firstStep?.maxSalary &&
                +firstStep?.maxSalary < +firstStep?.minSalary
                  ? "*Maksimal gaji tidak boleh lebih kecil daripada minimal gaji"
                  : "*Range gaji belum diisi"
              }
            />
          </div>
        </div>
      </div>

      <div className={`${Styles.formWrapper} ${Styles.formWrapperSalary}`}>
        <div className={Styles.rangeSalaryTitle}>
          <InputTitle title={"Minta foto kandidat"} required={true} />
          <div className={`${Styles.toggleButton}`}>
            <div className={Styles.icon}>
              <Icon icon={"information-solid"} size={20} color={"#1571DE"} />
            </div>

            <span>Kandidat akan diminta untuk melakukan swafoto</span>
          </div>
        </div>

        <div className={Styles.rangeSalaryInput}>
          <div className={Styles.formBox}>
            <div
              className={`${Styles.optionBox} ${
                validate && !firstStep?.photoCandidate && Styles.error
              }`}
            >
              <Radio
                isChecked={firstStep?.photoCandidate === "yes"}
                setIsChecked={() => handleChange("yes", "photoCandidate")}
              />

              <span>Ya, minta foto kandidat</span>
            </div>

            {validate && !firstStep?.photoCandidate && (
              <span className={Styles.spanError}>
                *Permintaan kebutuhan foto kandidat belum dipilih
              </span>
            )}
          </div>

          <div className={Styles.formBox}>
            <div
              className={`${Styles.optionBox} ${
                validate && !firstStep?.photoCandidate && Styles.error
              }`}
            >
              <Radio
                isChecked={firstStep?.photoCandidate === "no"}
                setIsChecked={() => handleChange("no", "photoCandidate")}
              />

              <span>Tidak, foto kandidat tidak diperlukan</span>
            </div>
          </div>
        </div>
      </div>

      <div className={`${Styles.formWrapper} ${Styles.formWrapperSalary}`}>
        <div className={Styles.rangeSalaryTitle}>
          <InputTitle
            title={"Minta Video Perkenalan kandidat"}
            required={true}
          />
          <div className={`${Styles.toggleButton}`}>
            <div className={Styles.icon}>
              <Icon icon={"information-solid"} size={20} color={"#1571DE"} />
            </div>

            <span>
              Kandidat akan diminta untuk melampirkan video perkenalan
            </span>
          </div>
        </div>

        <div className={Styles.rangeSalaryInput}>
          <div className={Styles.formBox}>
            <div
              className={`${Styles.optionBox} ${
                validate && !firstStep?.videoCandidate && Styles.error
              }`}
            >
              <Radio
                isChecked={firstStep?.videoCandidate === "yes"}
                setIsChecked={() => handleChange("yes", "videoCandidate")}
              />

              <span>Ya, minta video perkenalan</span>
            </div>

            {validate && !firstStep?.videoCandidate && (
              <span className={Styles.spanError}>
                *Permintaan kebutuhan video perkenalan belum dipilih
              </span>
            )}
          </div>

          <div className={Styles.formBox}>
            <div
              className={`${Styles.optionBox} ${
                validate && !firstStep?.videoCandidate && Styles.error
              }`}
            >
              <Radio
                isChecked={firstStep?.videoCandidate === "no"}
                setIsChecked={() => handleChange("no", "videoCandidate")}
              />

              <span>Tidak, video perkenalan tidak diperlukan</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
